import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { DialogStartVideoComponent } from '../dialog-start-video/dialog-start-video.component';
import { DialogStartTextComponent } from '../dialog-start-text/dialog-start-text.component';
import { trigger, transition, style, animate } from '@angular/animations';
import { ModuleTrackerService } from '../services/module-tracker.service';

@Component({
  selector: 'app-module-selector',
  templateUrl: './module-selector.component.html',
  styleUrls: ['./module-selector.component.scss'],
  animations: [
    trigger('fadeInUp', [
      transition(':enter', [
        style({ opacity: 0, transform: 'translateY(20px)' }),
        animate('0.3s ease-out', style({ opacity: 1, transform: 'translateY(0)' }))
      ])
    ])
  ]
})
export class ModuleSelectorComponent {
  constructor(
    private router: Router,
    private dialog: MatDialog,
    private moduleTracker: ModuleTrackerService
  ) {}

  navigateToModule(module: string) {
    this.moduleTracker.setActiveModule(module);
    this.router.navigate([`/${module}`]);
  }

  openVideoDialog() {
    const dialogRef = this.dialog.open(DialogStartVideoComponent, {
      disableClose: true,
      maxHeight: '95vh',
      maxWidth: 'min(95vw,1920px)',
      ariaLabel: 'Start Video Dialog'
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.navigateToModule('video');
      }
    });
  }

  openTextDialog() {
    const dialogRef = this.dialog.open(DialogStartTextComponent, {
      disableClose: true,
      maxHeight: '95vh',
      maxWidth: 'min(95vw,1920px)',
      ariaLabel: 'Start Text Dialog'
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.navigateToModule('text');
      }
    });
  }
} 